import axios from "axios";

const API = "http://localhost/backend/public/index.php?route=cedula";

export const consultarCedula = async (cedula, recaptchaToken) => {
  const { data } = await axios.post(API, {
    cedula,
    recaptchaToken
  });

  return data;
};
